<por-base-modal [id]="modalId" [modalWidth]="'modal-md'" [zIndex]="100">
    <div class="add-contact-modal">
        <div class="add-contact-modal__header">
            <h2>{{ 'AddContact.Title' | translate }}</h2>
        </div>

        <form [formGroup]="contactForm" class="add-contact-modal__form">
            <div class="add-contact-modal__fields">
                <div class="add-contact-modal__field">
                    <label class="add-contact-modal__label">{{ 'AddContact.FirstName' | translate }}</label>
                    <apx-form-field
                        [classList]="'required'"
                        [error]="firstName?.invalid && (firstName?.dirty || firstName?.touched) ?
                            firstName?.errors?.['required'] ? ('RequiredError' | translate) :
                            ''
                        : '' ">
                        <input apxInput formControlName="firstName" porAddFeature featureName="add-contact-first-name" />
                    </apx-form-field>
                </div>

                <div class="add-contact-modal__field">
                    <label class="add-contact-modal__label">{{ 'AddContact.LastName' | translate }}</label>
                    <apx-form-field
                        [classList]="'required'"
                        [error]="lastName?.invalid && (lastName?.dirty || lastName?.touched) ?
                            lastName?.errors?.['required'] ? ('RequiredError' | translate) :
                            ''
                        : '' ">
                        <input apxInput formControlName="lastName" porAddFeature featureName="add-contact-last-name" />
                    </apx-form-field>
                </div>

                <div class="add-contact-modal__field">
                    <label class="add-contact-modal__label">{{ 'AddContact.Email' | translate }}</label>
                    <apx-form-field
                        [error]="email?.invalid && (email?.dirty || email?.touched) ?
                            email?.errors?.['email'] ? ('EmailValid' | translate) :
                            ''
                        : '' ">
                        <input apxInput type="email" formControlName="email" porAddFeature featureName="add-contact-email" />
                    </apx-form-field>
                </div>

                <div class="add-contact-modal__field">
                    <label class="add-contact-modal__label">{{ 'AddContact.Phone' | translate }}</label>
                    <por-intl-tel-input
                        [cssClass]="'country-code'"
                        [enableAutoCountrySelect]="false"
                        [enablePlaceholder]="true"
                        [searchCountryFlag]="true"
                        [selectFirstCountry]="true"
                        [maxLength]="15"
                        [phoneValidation]="true"
                        [separateDialCode]="true"
                        formControlName="phone"
                        porAddFeature
                        featureName="add-contact-phone"></por-intl-tel-input>
                </div>
            </div>

            <div class="add-contact-modal__footer">
                <por-base-button class="theme-button" type="button" (onclick)="onCancel()">
                    {{ 'AddContact.Cancel' | translate }}
                </por-base-button>
                <por-base-button class="theme-button" type="button" [disabled]="contactForm.invalid || isSaving" (onclick)="onSave()">
                    {{ isSaving ? ('AddContact.Saving' | translate) : ('AddContact.Save' | translate) }}
                </por-base-button>
            </div>
        </form>
    </div>
</por-base-modal>
